import {startHeroScroll} from './heroScroll.util.js';

const {KitModule, registerModule} = window;

class SemicircleArt extends KitModule {
    constructor($element) {
        super($element);
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');
        this.syncMotion = this.syncMotion.bind(this);
        this.motionPreference.addEventListener('change', this.syncMotion);
        this.syncMotion();
    }

    syncMotion() {
        this.stopMotion();
        if (!this.motionPreference.matches) return;

        // Open space between the shapes while keeping their orientation and the text fixed.
        const transforms = [
            ['small', -14],
            ['red', -7],
            ['large', 12],
        ];
        const target = this.$element.closest('.engineering-article__header');
        this.stopHeroScroll = startHeroScroll({
            target,
            endViewport: 0.25,
            items: transforms.map(([shape, x]) => ({
                element: this.$element.querySelector(`.engineering-semicircles__${shape}`),
                x,
                unit: 'vw',
            })),
        });
    }

    stopMotion() {
        this.stopHeroScroll?.();
        this.stopHeroScroll = null;
    }

    unmount() {
        this.motionPreference.removeEventListener('change', this.syncMotion);
        this.stopMotion();
    }
}

registerModule('SemicircleArt', SemicircleArt);
